import React from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import api from "../servicios/api";
import { authHeaders } from "../servicios/auth";
function EditarinfraccionesWrapper(props) {
    const params = useParams();
   return <Editarinfracciones {...props} params={params} />;
}

class Editarinfracciones extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            datosCargados: false,
            id:"",
            articulo: "",
            inciso: "",
            descripcion:"",
            monto:"",
            mensaje: "",
            redireccionar: false
        };
    }

    cambioValor = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

componentDidMount() {
    const id = this.props.params.id;

    fetch(api + `infracciones/${id}`, {
        headers: authHeaders()
    })
    .then(respuesta => respuesta.json())
    .then((datosRespuesta) => {

       

        const infraccion = datosRespuesta[0];

        this.setState({
            datosCargadosinfracciones: true,
            idinfraccion: infraccion.idinfraccion,
            articulo: infraccion.articulo,
            inciso: infraccion.inciso,
            descripcion: infraccion.descripcion,
            monto: infraccion.monto
        });
    });
}

    enviarDatosinfracciones = (e) => {
    e.preventDefault();

    const { idinfraccion, articulo, inciso, descripcion, monto } = this.state;

    const datosEnviarinfraccion = {
        articulo,
        inciso,
        descripcion,
        monto
    };

    fetch(api + `infracciones/${idinfraccion}`, {
        method: "PUT",
        headers: authHeaders(),
        body: JSON.stringify(datosEnviarinfraccion)
    })
    .then(respuesta => respuesta.json())
    .then((datosRespuesta) => {

        

        if (datosRespuesta.success === 1) {
            this.setState({
                mensaje: "Infracción actualizada con éxito"
            });

            setTimeout(() => {
                this.setState({
                    redireccionar: true
                });
            }, 2000);
        } else {
            this.setState({
                mensaje: datosRespuesta.mensaje || "No se pudo actualizar la infracción"
            });
        }
    });
}





    render() {
        const { datosCargadosinfracciones, articulo,  inciso, descripcion, monto, mensaje, redireccionar } = this.state;

        if (redireccionar) {
            return <Navigate to="/infracciones" />;
        }

        return (
            <div className="card">
                <div className="card-header">
                    Editar Infracciones
                </div>

                <div className="card-body">
                    {mensaje && (
                        <div className="alert alert-success" role="alert">
                            {mensaje}
                        </div>
                    )}

                    {datosCargadosinfracciones ? (
                        <form onSubmit={this.enviarDatosinfracciones}>

                        

                            <div className="form-group">
                                <label htmlFor="articulo">Articulo</label>
                                <input
                                    type="text"
                                    name="articulo"
                                    onChange={this.cambioValor}
                                    value={articulo}
                                    id="articulo"
                                    className="form-control"
                                    placeholder=""
                                    aria-describedby="helpArticulo"
                                />
                                <small id="helparticulo" className="text-muted">
                                    Escribe el articulo 
                                </small>
                            </div>

                             <div className="form-group">
                                <label htmlFor="inciso">Inciso</label>
                                <input
                                    type="text"
                                    name="inciso"
                                    onChange={this.cambioValor}
                                    value={inciso}
                                    id="inciso"
                                    className="form-control"
                                    placeholder=""
                                    aria-describedby="helpinciso"
                                />
                                <small id="helparticulo" className="text-muted">
                                    Escribe el Inciso
                                </small>
                            </div>

                             <div className="form-group">
                                <label htmlFor="articulo">Descripcion</label>
                                <textarea
                                    type="text"
                                    name="descripcion"
                                    onChange={this.cambioValor}
                                    value={descripcion}
                                    id="descripcion"
                                    className="form-control"
                                    placeholder=""
                                    aria-describedby="helpdescripcion"
                               ></textarea>
                                <small id="helpdescripcion" className="text-muted">
                                    Escribe la descripción
                                </small>
                            </div>

<div className="form-group">
    <label htmlFor="monto">Monto Q</label>
    <input
        type="number"
        step="0.01"
        name="monto"
        id="monto"
        onChange={this.cambioValor}
        value={monto}
        className="form-control"
    />
    <small className="text-muted">
        Escribe el monto de la infracción
    </small>
</div>

                            

                            
                            <div className="btn-group" role="group" aria-label="">
                                <button type="submit" className="btn btn-success">
                                    Actualizar Infracciones
                                </button>

                                <Link to="/infracciones" className="btn btn-primary">
                                    Cancelar
                                </Link>

                                
                            </div>
                        </form>
                    ) : (
                        <p>Cargando datos...</p>
                    )}
                </div>

                <div className="card-footer text-muted">
                    PMT EN TODO
                </div>
            </div>
        );
    }
}

export default EditarinfraccionesWrapper;